import apiClient from "../api/config";

// Fetch active notifications via backend API (avoids Firestore reads on client)
export async function fetchActiveNotifications(limitCount = 30) {
  try {
    const response = await apiClient.get(`/api/in-app-notifications?limit=${limitCount}`);
    if (response.data.success) {
      return response.data.data.map((n) => ({
        ...n,
        // Normalize Firestore timestamps
        createdAt: n.createdAt?._seconds
          ? new Date(n.createdAt._seconds * 1000)
          : n.createdAt
            ? new Date(n.createdAt)
            : new Date(),
        displayDate: n.displayDate?._seconds
          ? new Date(n.displayDate._seconds * 1000)
          : n.displayDate
            ? new Date(n.displayDate)
            : null,
        expiryDate: n.expiryDate?._seconds
          ? new Date(n.expiryDate._seconds * 1000)
          : n.expiryDate
            ? new Date(n.expiryDate)
            : null,
      }));
    }
    return [];
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return [];
  }
}

// Get user notification status via backend API (bypasses Firestore Security Rules)
export async function getUserNotificationStatus(userId) {
  if (!userId) return { readNotificationIds: [], lastSeenAt: null };

  try {
    const response = await apiClient.get(`/api/user-notification-status/${userId}`);
    if (response.data.success) {
      return {
        readNotificationIds: response.data.data.readNotificationIds || [],
        lastSeenAt: response.data.data.lastSeenAt || null,
      };
    }
    return { readNotificationIds: [], lastSeenAt: null };
  } catch (error) {
    console.error("Error getting user notification status:", error);
    return { readNotificationIds: [], lastSeenAt: null };
  }
}

// Mark a notification as read via backend API
export async function markAsRead(userId, notificationId) {
  if (!userId || !notificationId) return;

  try {
    await apiClient.post(`/api/user-notification-status/${userId}/mark-read`, {
      notificationId,
    });
  } catch (error) {
    console.error("Error marking notification as read:", error);
  }
}

// Update lastSeenAt when user opens popup via backend API
export async function updateLastSeen(userId) {
  if (!userId) return;

  try {
    await apiClient.post(`/api/user-notification-status/${userId}/update-last-seen`);
  } catch (error) {
    console.error("Error updating last seen:", error);
  }
}

// Calculate unread count
export function getUnreadCount(notifications, readNotificationIds) {
  if (!notifications || !Array.isArray(notifications)) return 0;
  const readSet = new Set(readNotificationIds || []);
  return notifications.filter((n) => !readSet.has(n.id)).length;
}
